import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"80vh"}
}
const _hoisted_4 = {
  key: 1,
  class: "contents-wrapper"
}
const _hoisted_5 = { class: "pa-2 mt-1" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = {
  key: 1,
  class: "pa-4 text-center"
}
const _hoisted_10 = {
  key: 0,
  class: "pa-2"
}
const _hoisted_11 = { class: "legend-container mb-8" }
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = { class: "text-caption ml-1" }
const _hoisted_14 = { class: "d-flex align-center mt-1" }
const _hoisted_15 = { class: "text-caption ml-1" }
const _hoisted_16 = { class: "legend-container mb-10" }
const _hoisted_17 = { class: "d-flex align-center" }
const _hoisted_18 = { class: "text-caption ml-1" }
const _hoisted_19 = { class: "d-flex align-center mt-1" }
const _hoisted_20 = { class: "text-caption ml-1" }
const _hoisted_21 = {
  key: 1,
  class: "pa-4 text-center"
}
const _hoisted_22 = { class: "text-caption text-grey-darken-1" }
const _hoisted_23 = { class: "text-body-1 mb-3" }
const _hoisted_24 = { class: "text-caption text-grey-darken-1" }
const _hoisted_25 = { class: "text-body-1 mb-3" }
const _hoisted_26 = { class: "text-caption text-grey-darken-1" }
const _hoisted_27 = {
  class: "text-body-1",
  style: {"white-space":"pre-wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_GChart = _resolveComponent("GChart")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_v_btn, {
              onClick: _ctx.routerBack,
              icon: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"60%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_vue_loading, {
            active: _ctx.fetchLoading,
            loader: "bars",
            color: "#EE6090",
            size: { width: '30px', height: '30px' }
          }, null, 8, ["active"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.tabs,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabs) = $event)),
            "fixed-tabs": "",
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, { value: "memory" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('growth.memory')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_tab, { value: "graph" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('growth.graph')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.selectedNendo,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedNendo) = $event)),
                _ctx.changeNendo
              ],
              items: _ctx.nendoOptions,
              label: _ctx.t('growth.nendo'),
              variant: "outlined",
              "hide-details": "",
              density: "compact"
            }, null, 8, ["modelValue", "items", "label", "onUpdate:modelValue"])
          ]),
          _createVNode(_component_v_window, {
            modelValue: _ctx.tabs,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabs) = $event)),
            class: "pb-16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "memory" }, {
                default: _withCtx(() => [
                  (_ctx.growths && _ctx.growths.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_table, {
                        key: 0,
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.t('growth.implementationMonth')), 1),
                              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.t('growth.height')), 1),
                              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.t('growth.weight')), 1),
                              _cache[6] || (_cache[6] = _createElementVNode("th", { class: "text-left" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.growths, (g) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${g.year}-${g.month}`
                              }, [
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatMonthName(g.month)), 1),
                                _createElementVNode("td", null, _toDisplayString(g.height) + "cm", 1),
                                _createElementVNode("td", null, _toDisplayString(g.weight) + "kg", 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_v_btn, {
                                    onClick: ($event: any) => (_ctx.toggleDetail(g)),
                                    color: "primary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('growth.show')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.t('growth.noData')), 1)
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "graph" }, {
                default: _withCtx(() => [
                  (_ctx.growths && _ctx.growths.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_GChart, {
                          type: "ComboChart",
                          data: _ctx.heightChartData,
                          options: _ctx.chartOptions(_ctx.t('growth.height'))
                        }, null, 8, ["data", "options"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "skyblue-legend" }, null, -1)),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('growth.percentileRange')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "legend-line-group" }, [
                              _createElementVNode("div", { class: "legend-line" }),
                              _createElementVNode("div", { class: "legend-dot" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('growth.height')), 1)
                          ])
                        ]),
                        _createVNode(_component_GChart, {
                          type: "ComboChart",
                          data: _ctx.weightChartData,
                          options: _ctx.chartOptions(_ctx.t('growth.weight'))
                        }, null, 8, ["data", "options"]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "skyblue-legend" }, null, -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('growth.percentileRange')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "legend-line-group" }, [
                              _createElementVNode("div", { class: "legend-line" }),
                              _createElementVNode("div", { class: "legend-dot" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('growth.weight')), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.t('growth.noData')), 1)
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDetail,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDetail) = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedGrowth)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-h6 text-center" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatMonthName(_ctx.selectedGrowth.month)) + " " + _toDisplayString(_ctx.selectedGrowth.child.lastName) + " " + _toDisplayString(_ctx.selectedGrowth.child.firstName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t('growth.height')), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedGrowth.height) + "cm", 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t('growth.weight')), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.selectedGrowth.weight) + "kg", 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t('growth.remarks')), 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.selectedGrowth.remarks), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetail = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('growth.close')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}